<template>
    <div class="workload-wrapper">
        <div class="common-border margin-b20">
            <div class="big-title flex-sb">
                <div>数据总览</div>
                <el-popover
                        ref="popover"
                        class="popover"
                        placement="bottom"
                        :offset="-20"
                        trigger="click"
                >
                    <div>
                        <el-date-picker
                                v-model="queryData.date"
                                :clearable="false"
                                class="datepicker"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始月份"
                                end-placeholder="结束月份"
                                :picker-options="pickerOptions"
                                @change="dateSet"
                        ></el-date-picker>
                    </div>
                    <div slot="reference" class="date flex">
                        <img src="@/assets/img/workbench/date.png" height="16px" alt="" style="margin-right: 4px"/>
                        <p style="margin-right: 20px">
                            {{ getFormatDate(queryData.date) }}
                            <i class="el-icon-arrow-down"></i>
                        </p>
                        <div class="import-box">
                            <img src="@/assets/img/workbench/import-data.png" height="14px" alt=""/>
                        </div>
                        <eui-btn type="text" @click="exportDataOverview">导出</eui-btn>
                    </div>
                </el-popover>
            </div>
            <div class="chart-wrapper flex">
                <!-- 采购数量-->
                <div id="purchaseQuantityChart"></div>
                <!-- 采购金额-->
                <div id="purchaseAmountChart"></div>
            </div>
        </div>
        <div class="common-border">
            <div class="big-title flex-sb">
                <div>数据详情</div>
                <el-popover
                        ref="popover"
                        class="popover"
                        placement="bottom"
                        :offset="-20"
                        trigger="click"
                >
                    <div>
                        <el-date-picker
                                v-model="queryData.detailDate"
                                :clearable="false"
                                class="datepicker"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始月份"
                                end-placeholder="结束月份"
                                :picker-options="pickerOptions"
                        ></el-date-picker>
                    </div>
                    <div slot="reference" class="date flex">
                        <img src="@/assets/img/workbench/date.png" height="16px" alt="" style="margin-right: 4px"/>
                        <p style="margin-right: 20px">
                            {{ getFormatDate(queryData.detailDate) }}
                            <i class="el-icon-arrow-down"></i>
                        </p>
                        <div class="import-box">
                            <img src="@/assets/img/workbench/import-data.png" height="14px" alt=""/>
                        </div>
                        <eui-btn type="text" @click="exportDataInfo">导出</eui-btn>
                    </div>
                </el-popover>
            </div>
            <div class="search-wrapper">
                <e-search
                        :data="filterInfo.data"
                        :field-list="filterInfo.fieldList"
                        :list-type-info="listTypeInfo"
                        @handleFilter="handleFilter"
                        @handleReset="handleReset"
                ></e-search>
            </div>
            <div class="content-wrapper">
                <div class="data-wrapper">
                    <div class="data-item" v-for="(item,index) in dataInfo" :key="index">
                        <div class="title">{{item.name}}</div>
                        <div class="num-change flex-sb">
                            <eui-tooltip-over class="num" :tooltipStyle="{ 'width': '92px' }"
                                              :content="Number(item.num).toLocaleString()">
                                <span>{{Number(item.num).toLocaleString() }}</span>
                            </eui-tooltip-over>
                            <div class="num-up" v-if="item.flag === 1">
                                <eui-icon icon="eicon-r-l-zhishijiantouzhuangtaishangjiantou" font-size="16px"
                                          style="margin-right: -4px"></eui-icon>
                                {{Number(item.ratio* 100).toFixed(2)}}%
                            </div>
                            <div class="num-down" v-else-if="item.flag === 0">
                                <eui-icon icon="eicon-r-l-zhishijiantouzhuangtaixiajiantou" font-size="16px"
                                          style="margin-right: -4px"></eui-icon>
                                {{Number(item.ratio* 100).toFixed(2)}}%
                            </div>
                            <div v-else>--</div>
                        </div>
                    </div>
                </div>
                <div class="no-data-wrapper flex-column" v-if="dataInfo.length === 0">
                    <img src="../../../../assets/img/no-data.png" alt="">
                    <div>请先选择采购员后查看数据</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import eSearch from '../../components/common/e-search';
import {dateformate} from '@/modules/projectA/utils/utils';
import Api from '@/modules/projectA/api/dataCenter';
import utils from '@/modules/projectA//utils/utils';

export default {
  components: {
    eSearch
  },
  data() {
    return {
      queryData: {
        date: [
          new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 30),
          new Date(),
        ],
        detailDate: [
          new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 30),
          new Date(),
        ],
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      quantityChart: {
        title: {
          text: '采购数量',
          textStyle: {
            fontSize: 14,
            color: '#333',
            fontWeight: 'normal'
          },
          padding: [20, 0, 10, 20]
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          }
        },
        legend: {
          top: 'bottom',
          icon: 'circle',
        },
        grid: {
          top: '18%',
          left: '3%',
          right: '6%',
          bottom: '14%',
          containLabel: true
        },
        xAxis: {
          type: 'value'
        },
        yAxis: {
          type: 'category',
          data: []
        },
        series: [
          {
            name: '需求计划',
            type: 'bar',
            stack: 'total',
            label: {
              show: false
            },
            emphasis: {
              focus: 'series'
            },
            color: '#6AA1FF',
            data: []
          },
          {
            name: '采购计划',
            type: 'bar',
            stack: 'total',
            label: {
              show: false
            },
            emphasis: {
              focus: 'series'
            },
            color: '#5EDFD6',
            data: []
          },
          {
            name: '询比价',
            type: 'bar',
            stack: 'total',
            label: {
              show: false
            },
            emphasis: {
              focus: 'series'
            },
            color: '#C9E968',
            data: []
          },
          {
            name: '标品比价',
            type: 'bar',
            stack: 'total',
            label: {
              show: false
            },
            emphasis: {
              focus: 'series'
            },
            color: '#FADC6D',
            data: []
          },
          {
            name: '订单',
            type: 'bar',
            stack: 'total',
            label: {
              show: false
            },
            emphasis: {
              focus: 'series'
            },
            color: '#E865DF',
            data: []
          },
          {
            name: '采购协议',
            type: 'bar',
            stack: 'total',
            label: {
              show: false
            },
            emphasis: {
              focus: 'series'
            },
            color: '#F98981',
            data: []
          },
        ]
      },
      amountChart: {
        title: {
          text: '采购金额',
          textStyle: {
            fontSize: 14,
            color: '#333',
            fontWeight: 'normal'
          },
          padding: [20, 0, 10, 20]
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          }
        },
        legend: {
          top: 'bottom',
          icon: 'circle',
        },
        grid: {
          top: '26%',
          left: '0%',
          right: '10%',
          bottom: '14%',
          containLabel: true
        },
        xAxis: {
          type: 'value'
        },
        yAxis: {
          type: 'category',
          name: '数量（个）',
          data: []
        },
        series: [
          {
            name: '需求计划',
            type: 'bar',
            stack: 'total',
            label: {
              show: false
            },
            emphasis: {
              focus: 'series'
            },
            color: '#6AA1FF',
            data: []
          },
          {
            name: '采购计划',
            type: 'bar',
            stack: 'total',
            label: {
              show: false
            },
            emphasis: {
              focus: 'series'
            },
            color: '#5EDFD6',
            data: []
          },
          {
            name: '询比价',
            type: 'bar',
            stack: 'total',
            label: {
              show: false
            },
            emphasis: {
              focus: 'series'
            },
            color: '#C9E968',
            data: []
          },
          {
            name: '标品比价',
            type: 'bar',
            stack: 'total',
            label: {
              show: false
            },
            emphasis: {
              focus: 'series'
            },
            color: '#FADC6D',
            data: []
          },
          {
            name: '订单',
            type: 'bar',
            stack: 'total',
            label: {
              show: false
            },
            emphasis: {
              focus: 'series'
            },
            color: '#E865DF',
            data: []
          },
        ]
      },
      purchaseQuantityChart: null,
      purchaseAmountChart: null,
      filterInfo: {
        data: {
          memberId: null,
        },
        fieldList: [{label: '采购员', type: 'select', value: 'memberId', list: 'procurementList'},]
      },
      listTypeInfo: {
        procurementList: [],
      },
      memberId: null,
      dataInfo: [],
    }
  },
  methods: {
    //数据总览-导出
    async exportDataOverview() {
      let params = {
        startTime: this.formatDate(this.queryData.date[0]),
        endTime: this.formatDate(this.queryData.date[1]),
      }
      const res = await Api.exportDataOverview(params);
      if (res.type == 'application/json') {
        utils.fileExportResponseError(res);
      } else {
        utils.downFile(res, '数据总览');
      }
    },
    //数据详情-导出
    async exportDataInfo() {
      if (!this.memberId) {
        this.$message.warning('请先选择采购员后下载数据。');
        return false;
      }
      let params = {
        startTime: this.formatDate(this.queryData.detailDate[0]),
        endTime: this.formatDate(this.queryData.detailDate[1]),
        memberId: this.memberId
      }
      const res = await Api.exportDataInfo(params);
      if (res.type == 'application/json') {
        utils.fileExportResponseError(res);
      } else {
        utils.downFile(res, '数据详情');
      }
    },
    getFormatDate(val) {
      return `${dateformate(
        val[0],
        'yyyy年MM月'
      )}-${dateformate(val[1], 'yyyy年MM月')}`;
    },
    formatDate(date) {
      return `${dateformate(date, 'yyyy-MM-dd')}`;
    },
    dateSet() {
      this.purchaseAmount();
      this.purchaseQuantity();
    },
    handleReset() {
      this.memberId = null;
      this.dataInfo = [];
    },
    handleFilter(val) {
      this.memberId = val.memberId;
      if (this.memberId) {
        this.dataInfo = [];
        this.queryDataInfo();
      } else {
        this.$message.warning('请先选择采购员后查看数据。');
      }
    },
    //采购数量
    async purchaseQuantity() {
      let params = {
        startTime: this.formatDate(this.queryData.date[0]),
        endTime: this.formatDate(this.queryData.date[1]),
      };
      let res = await Api.queryDataOverviewCount(params);
      if (res.code === '200') {
        const data = res.data || [];
        this.quantityChart.yAxis.data = data.map(item => item.memberRealName);
        this.quantityChart.series[0].data = data.map(item => item.demandCount);//需求计划
        this.quantityChart.series[1].data = data.map(item => item.planCount);//采购计划
        this.quantityChart.series[2].data = data.map(item => item.enquiryCount);//询比价
        this.quantityChart.series[3].data = data.map(item => item.comparisonCount);//标品比价
        this.quantityChart.series[4].data = data.map(item => item.orderCount);//订单
        this.quantityChart.series[5].data = data.map(item => item.agreementCount);//采购协议
      }

      this.purchaseQuantityChart = this.$echarts.init(document.getElementById('purchaseQuantityChart'));
      this.purchaseQuantityChart.setOption(this.quantityChart);
    },
    //采购金额
    async purchaseAmount() {
      let params = {
        startTime: this.formatDate(this.queryData.date[0]),
        endTime: this.formatDate(this.queryData.date[1]),
      };
      let res = await Api.queryDataOverviewAmount(params);
      if (res.code === '200') {
        const data = res.data || [];
        this.amountChart.yAxis.data = data.map(item => item.memberRealName);
        this.amountChart.series[0].data = data.map(item => item.demandAmount);//需求计划
        this.amountChart.series[1].data = data.map(item => item.planAmount);//采购计划
        this.amountChart.series[2].data = data.map(item => item.enquiryAmount);//询比价
        this.amountChart.series[3].data = data.map(item => item.comparisonAmount);//标品比价
        this.amountChart.series[4].data = data.map(item => item.orderAmount);//订单
      }
      this.purchaseAmountChart = this.$echarts.init(document.getElementById('purchaseAmountChart'));
      this.purchaseAmountChart.setOption(this.amountChart);
    },
    //数据详情
    async queryDataInfo() {
      let params = {
        startTime: this.formatDate(this.queryData.detailDate[0]),
        endTime: this.formatDate(this.queryData.detailDate[1]),
        memberId: this.memberId
      };
      let res = await Api.queryDataInfo(params);
      if (res.code === '200') {
        const data = res.data;
        this.dataInfo.push({
          name: '需求计划数',
          num: data.demandCount,
          flag: data.demandCountFlag,
          ratio: data.demandCountRatio
        });//flag标识(0:下降 1:上升)
        this.dataInfo.push({
          name: '需求计划金额',
          num: data.demandAmount,
          flag: data.demandAmountFlag,
          ratio: data.demandAmountRatio
        });//flag标识(0:下降 1:上升)
        this.dataInfo.push({name: '采购计划数', num: data.planCount, flag: data.planCountFlag, ratio: data.planCountRatio});//flag标识(0:下降 1:上升)
        this.dataInfo.push({
          name: '采购计划金额',
          num: data.planAmount,
          flag: data.planAmountFlag,
          ratio: data.planAmountRatio
        });//flag标识(0:下降 1:上升)
        this.dataInfo.push({
          name: '询比价数',
          num: data.enquiryCount,
          flag: data.enquiryCountFlag,
          ratio: data.enquiryCountRatio
        });//flag标识(0:下降 1:上升)
        this.dataInfo.push({
          name: '询比价金额',
          num: data.enquiryAmount,
          flag: data.enquiryAmountFlag,
          ratio: data.enquiryAmountRatio
        });//flag标识(0:下降 1:上升)
        this.dataInfo.push({
          name: '标品比价数',
          num: data.comparisonCount,
          flag: data.comparisonCountFlag,
          ratio: data.comparisonCountRatio
        });//flag标识(0:下降 1:上升)
        this.dataInfo.push({
          name: '标品比价金额',
          num: data.comparisonAmount,
          flag: data.comparisonAmountFlag,
          ratio: data.comparisonAmountRatio
        });//flag标识(0:下降 1:上升)
        this.dataInfo.push({name: '订单数', num: data.orderCount, flag: data.orderCountFlag, ratio: data.orderCountRatio});//flag标识(0:下降 1:上升)
        this.dataInfo.push({
          name: '订单金额',
          num: data.orderAmount,
          flag: data.orderAmountFlag,
          ratio: data.orderAmountRatio
        });//flag标识(0:下降 1:上升)
        this.dataInfo.push({
          name: '采购协议数',
          num: data.agreementCount,
          flag: data.agreementCountFlag,
          ratio: data.agreementCountRatio
        });//flag标识(0:下降 1:上升)
      }
    },
    //采购员列表
    async queryMemberList() {
      let res = await Api.queryMemberList();
      if (res.code === '200') {
        this.listTypeInfo.procurementList = res.data.map(({memberId, memberRealName}) => ({
          id: memberId,
          name: memberRealName
        }));
      }
    },
  },
  mounted() {
    this.purchaseQuantity();
    this.purchaseAmount();
    this.queryMemberList();
  }
}
</script>

<style scoped lang="scss">
.workload-wrapper {
    .popover {
        ::v-deep .el-popover__reference {
            display: flex;
            align-items: center;
            color: #333;
            font-size: 12px;
        }
    }

    .datepicker {
        ::v-deep .el-range-separator {
            width: 30px !important;
        }
    }

    .import-box {
        margin-right: 4px;
        color: #2587FF;
        padding-left: 20px;
        border-left: 1px solid #D9D9D9;
        height: 16px;
        line-height: 16px;

        img {
            color: #2587FF;
        }
    }

    .common-border {
        width: 100%;
        border: 1px solid #D9D9D9;
    }

    .big-title {
        width: 100%;
        height: 44px;
        line-height: 44px;
        background-color: #F5F5F5;
        border-bottom: 1px solid #D9D9D9;
        padding: 0 20px;
        color: #333;
        font-size: 14px;
        font-family: SourceHanSansCN-Medium;
    }

    .chart-wrapper {
        height: 278px;
        background-color: #FFF;

        div {
            width: 50%;
            height: 260px;
        }
    }

    .search-wrapper {
        background-color: #fff;
        padding: 20px 0;
        border-bottom: 1px solid #D9D9D9;
    }

    .content-wrapper {
        background-color: #fff;

        .data-wrapper {
            padding: 20px 20px 0 20px;
            display: flex;
            flex-wrap: wrap;

            .data-item {
                width: 195px;
                height: 72px;
                background-color: #F4F7FF;
                padding: 12px 10px;
                margin-right: 20px;
                margin-bottom: 20px;

                .title {
                    font-size: 14px;
                    color: #666;
                    margin-bottom: 6px;
                }

                .num-change {
                    font-family: SourceHanSansCN-Medium;

                    .num {
                        font-size: 16px;
                        color: #333;
                    }

                    .num-up {
                        font-size: 14px;
                        color: #F0250F;
                    }

                    .num-down {
                        font-size: 14px;
                        color: #50AA43;
                    }
                }
            }
        }

        .no-data-wrapper {
            padding: 50px 0;

            img {
                width: 210px;
                height: 160px;
            }

            div {
                font-size: 16px;
                margin-top: 20px;
                color: #333;
                font-family: SourceHanSansCN-Medium;
            }
        }
    }
}
</style>